module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-398.af7f0d1f.jpg";